var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "team_management_svg__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.05,
    cy: 29.92,
    r: 11.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("style", null, ".team_management_svg__cls-2,.team_management_svg__cls-4,.team_management_svg__cls-7{fill:#e8eaeb}.team_management_svg__cls-4,.team_management_svg__cls-7{stroke:#1a2e3b;stroke-width:2px}.team_management_svg__cls-4{stroke-miterlimit:10;stroke-linecap:round}.team_management_svg__cls-7{stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_management_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team_management_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "team_management_svg__cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "team_management_svg__cls-2",
    cx: 39.05,
    cy: 29.87,
    r: 11.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.05,
    cy: 29.87,
    r: 11.21,
    transform: "rotate(-32.23 39.054 29.865)",
    strokeDasharray: "1.96 3.91",
    strokeMiterlimit: 10,
    stroke: "#1a2e3b",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "team_management_svg__cls-4",
    cx: 21.05,
    cy: 29.87,
    r: 11.21
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#team_management_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.05 47.5l-1.69-12.45a2 2 0 00-2-1.73h-8.59a2 2 0 00-2 1.71L13 47.43",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    stroke: "#1a2e3b",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "team_management_svg__cls-4",
    cx: 21.11,
    cy: 28.8,
    r: 3.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "team_management_svg__cls-7",
    d: "M39.35 25.92v8M43.35 29.92h-8"
  })))));
}
export default SvgTeamManagement;